import { useItemExpectedDelivery } from "@coworker/apprestructured/src/shared/hooks/item/useItemExpectedDelivery";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import DeliveryTruckIconPath from "@ingka/ssr-icon/paths/delivery-truck";
import { ItemDeliveryDate } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDeliveryDate/ItemDeliveryDate";
import { ItemDeliveryQuantity } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDeliveryQuantity/ItemDeliveryQuantity";
import styles from "./item-delivery.module.css";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
interface ItemDeliveryProps {
  itemNo: string;
}

export const ItemDelivery = ({ itemNo }: ItemDeliveryProps) => {
  const storeId = useStoreId();
  const { data: itemDeliveryData, isLoading: isLoading } =
    useItemExpectedDelivery(itemNo, storeId);

  if (!isLoading && !itemDeliveryData?.deliveryDate) {
    return null;
  }

  return (
    <>
      <Spacer />
      <div className={styles["item-delivery-container"]}>
        {isLoading && <FixaSkeleton width="50%" height="16px" />}
        {!isLoading && itemDeliveryData?.deliveryDate && (
          <>
            <FixaSSRIcon
              className={styles["item-delivery-icon"] ?? ""}
              paths={DeliveryTruckIconPath}
            />
            <ItemDeliveryDate deliveryDate={itemDeliveryData?.deliveryDate} />
            <ItemDeliveryQuantity
              quantity={itemDeliveryData?.deliveryQuantity}
            />
          </>
        )}
      </div>
    </>
  );
};
